module.exports = __webpack_public_path__ + "img/ring_r_o_0_0.205a9ce2.png";